import { render, staticRenderFns } from "./MonthlyTrendChart.vue?vue&type=template&id=1c126fa4&scoped=true&"
import script from "./MonthlyTrendChart.vue?vue&type=script&lang=js&"
export * from "./MonthlyTrendChart.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyTrendChart.vue?vue&type=style&index=0&id=1c126fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c126fa4",
  null
  
)

export default component.exports